module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"story_setting":"故事设置","next_step":"下一步"},"en":{"story_setting":"Story Setting","next_step":"Next Step"}}')
  delete Component.options._Ctor
}
